import { join } from 'ramda'

import { LOAD_AGENDA_ITEM } from '../actionTypes'

export const loadAgendaItem = (agenda_item_id: string | undefined) => ({
  type: LOAD_AGENDA_ITEM.name,
  api: {
    url: 'agenda_items/info',
    data: {
      agenda_item_id,
      field_list: join(',', [
        'agenda_item_id',
        'title',
        'start_date',
        'start_time',
        'end_date',
        'end_time',
        'attire',
        'location_name',
        'location_address',
        'location_city',
        'location_state',
        'location_zip',
        'location_lat',
        'location_lon',
        'notes',
        'url',
        'log',
        'access_mode',
        'guest_whitelist',
      ]),
    },
  },
})
